module.exports = __webpack_public_path__ + "static/media/hunter.724823e2.png";